/**
 * Daily Affirmation Model
 * AI-generated affirmation content personalized to user intentions
 */
export interface Affirmation {
  id: string;
  text: string;
  generatedAt: Date | string;
  displayDate: Date | string;
  relatedIntentions: string[]; // Array of intention IDs
  displayFormat?: string;
  highlightedWords?: string[]; // Array of words to highlight with Didot italic
}

export function createAffirmation(
  text: string,
  relatedIntentions: string[],
  displayDate?: Date | string
): Affirmation {
  return {
    id: crypto.randomUUID(),
    text,
    generatedAt: new Date().toISOString(),
    displayDate: displayDate || new Date().toISOString(),
    relatedIntentions,
    displayFormat: 'default',
  };
}
